// extracted by mini-css-extract-plugin
module.exports = {"pieChart":"pie-chart_pieChart_14rHY"};